module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "gPageBorder pushObjectDetail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.animatName))]), _vm._v(" "), _c('el-row', {
    staticClass: "detail",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("动画类型:")]), _vm._v(_vm._s(_vm.aType[_vm.info.animatType]))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("动画大小:")]), _vm._v(_vm._s(_vm.info.size))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("渠道商:")]), _vm._v("无")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("上传时间:")]), _vm._v(_vm._s(_vm.info.createTime))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pLoading),
      expression: "pLoading"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_pushHistory')))]), _vm._v(" "), _c('div', {
    staticClass: "subTitle_buttonBar"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.jumpToPush()
      }
    }
  }, [_vm._v("添加推送")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("批量还原(" + _vm._s(_vm.multipleSelection.length || 0) + ")")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechanismName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "nums",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "pushTime",
      "label": _vm.$t('app_pushTime'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_clear'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('paging', {
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px",
      "margin-bottom": "20px"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d93526c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/onoff/push.vue
// module id = 1096
// module chunks = 0